import { render } from "./WhatsAppMetaHeader.vue?vue&type=template&id=0e6ff959&ts=true"
import script from "./WhatsAppMetaHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppMetaHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/WhatsAppMetaHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e6ff959"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e6ff959', __exports__)) {
    api.reload('0e6ff959', __exports__)
  }
  
  module.hot.accept("./WhatsAppMetaHeader.vue?vue&type=template&id=0e6ff959&ts=true", () => {
    api.rerender('0e6ff959', render)
  })

}


export default __exports__